export const appLanguageOptions = [
    { value: "es", label: "Español" },
    { value: "en", label: "English" },
];
export const utilityEmailLanguageOptions = appLanguageOptions;
export const customerLanguageOptions = [
    { value: "en", label: "English" },
    { value: "es", label: "Español" },
    { value: "es-CR", label: "Español (Costa Rica)" },
    { value: "es-MX", label: "Español (México)" },
    { value: "fr", label: "Français" },
    { value: "fr-CA", label: "Français (Canada)" },
    { value: "de", label: "Deutsch" },
    { value: "it", label: "Italiano" },
    { value: "pt-BR", label: "Português (Brasil)" },
    { value: "nl", label: "Nederlands" },
    { value: "zh-Hans", label: "中文（简体）" },
    { value: "ja", label: "日本語" },
    { value: "ko", label: "한국어" },
];
export function normalizeLanguageInput(value) {
    if (typeof value !== "string")
        return null;
    const trimmed = value.trim();
    return trimmed ? trimmed : null;
}
